import { Chip, Typography, useTheme } from '@mui/material'
import { Field, FieldProps } from 'formik'

import useStyles from './index.styles'

const ReleaseTagField = () => {
  const classes = useStyles
  const theme = useTheme()

  return (
    <>
      <Typography variant="body1" sx={classes.inlineBlockTypography}>
        Select one
        <span style={classes.chipsRequiredAsterisk}>*</span>:
      </Typography>

      <Field name="level">
        {({ field, form }: FieldProps) => (
          <>
            <Chip
              label="Major"
              onClick={() => form.setFieldValue('level', 'major', true)}
              sx={{
                ...classes.releaseNoteChip(theme),
                ...(field.value === 'major' ? classes.majorChip(theme) : classes.majorChipNotSelected(theme)),
              }}
            />
            <Chip
              label="Minor"
              onClick={() => form.setFieldValue('level', 'minor', true)}
              sx={{
                ...classes.releaseNoteChip(theme),
                ...(field.value === 'minor' ? classes.minorChip(theme) : classes.minorChipNotSelected(theme)),
              }}
            />
          </>
        )}
      </Field>
    </>
  )
}

export default ReleaseTagField
